function timestampToISO(timestamp) {
  return new Date(timestamp / 1e6).toISOString();
}
export {
  timestampToISO
};
